import {
  getBreadCrumbList,
  getMenuByRouter,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead,
} from '@/libs/util';
import router from '@/router';
import config from '@/config';
const { homeName } = config;

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route);
  const tagNavList = state.tagNavList.filter((item) => {
    return !routeEqual(item, route);
  });
  state.tagNavList = tagNavList;
  sessionStorage.setItem('tagNavList', JSON.stringify(tagNavList));
  router.push(nextRoute);
};

const getTagNavList = () => {
  const tabNavList = sessionStorage.getItem('tagNavList');
  return tabNavList ? JSON.parse(tabNavList) : [];
};

export default {
  state: {
    breadCrumbList: [],
    tagNavList: getTagNavList(),
    homeRoute: {},
    local: localRead('local'),
    access: sessionStorage.getItem('access') || [],
  },
  getters: {
    menuList: (state) => {
      return getMenuByRouter(router.options.routes, state.access); // rootState.user.getters.access);
    },
  },
  mutations: {
    setBreadCrumb(state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute);
    },
    setHomeRoute(state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName);
    },
    setAccess(state, access) {
      state.access = access;
      sessionStorage.setItem('access', access);
    },
    refreshAccess(state) {
      state.access = sessionStorage.getItem('access');
    },
    setTagNavList(state, list) {
      let tagList = [];
      if (list) {
        tagList = [...list];
      } else {
        tagList = state.tagNavList || [];
        if (tagList[0] && tagList[0].name !== homeName) tagList.shift();
        const homeTagIndex = tagList.findIndex(
          (item) => item.name === homeName,
        );
        if (homeTagIndex > 0) {
          const homeTag = tagList.splice(homeTagIndex, 1)[0];
          tagList.unshift(homeTag);
        }
      }
      state.tagNavList = tagList;
      sessionStorage.setItem('tagNavList', JSON.stringify(tagList));
    },
    closeTag(state, route) {
      const tag = state.tagNavList.filter((item) => routeEqual(item, route));
      route = tag[0] ? tag[0] : null;
      if (!route) return false;
      closePage(state, route);
    },
    addTag(state, { route, type = 'unshift' }) {
      const router = getRouteTitleHandled(route);
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router);
        else {
          if (router.name === homeName) state.tagNavList.unshift(router);
          else state.tagNavList.splice(1, 0, router);
        }
      }
      sessionStorage.setItem('tagNavList', JSON.stringify(state.tagNavList));

      //记录点击过的nav
      let favItem = localStorage.getItem('favItem');
      if (favItem == null) {
        favItem = [];
        favItem.push({
          title: router.meta.title,
          name: router.name,
          count: 1,
          icon: router.meta.icon,
        });
      } else {
        let update = false;
        favItem = JSON.parse(favItem);
        favItem.forEach((element) => {
          if (element.name == router.name) {
            element.count += 1;
            update = true;
            return;
          }
        });
        if (!update)
          favItem.push({
            title: router.meta.title,
            name: router.name,
            count: 1,
            icon: router.meta.icon,
          });
      }
      localStorage.setItem('favItem', JSON.stringify(favItem));
    },
    setLocal(state, lang) {
      localSave('local', lang);
      state.local = lang;
    },
  },
};
